export enum ItemType {
  "ARTICLE" = "ART",
  "LOCAL_COMBINATION" = "SCI",
  "UNKNOWN" = "Unknown",
}

export const UNKNOWN_ITEM_NAME = "unknown";
